module.exports = "/assets/data/2bd8a77fc8076e1082a44f79866ecfe5-EC1Y.data.json";